const elements = document.querySelectorAll('.color_swatch_child-1');

// Füge jedem Element einen Event-Listener für das "mouseover"-Ereignis hinzu
elements.forEach(function(element) {
  element.addEventListener('mouseover', function() {
    // Entferne die Klasse "active" von allen Elementen mit der Klasse "test"
    elements.forEach(function(el) {
      el.classList.remove('active');
    });
    // Füge die Klasse "active" nur zum gehoverten Element hinzu
    element.classList.add('active');
  });
});


const elements1 = document.querySelectorAll('.color_swatch_child-2');

// Füge jedem Element einen Event-Listener für das "mouseover"-Ereignis hinzu
elements1.forEach(function(element1) {
  element1.addEventListener('mouseover', function() {
    // Entferne die Klasse "active" von allen Elementen mit der Klasse "test"
    elements1.forEach(function(el1) {
      el1.classList.remove('active');
    });
    // Füge die Klasse "active" nur zum gehoverten Element hinzu
    element1.classList.add('active');
  });
});


const elements2 = document.querySelectorAll('.color_swatch_child-3');

// Füge jedem Element einen Event-Listener für das "mouseover"-Ereignis hinzu
elements2.forEach(function(element2) {
  element2.addEventListener('mouseover', function() {
    // Entferne die Klasse "active" von allen Elementen mit der Klasse "test"
    elements2.forEach(function(el2) {
      el2.classList.remove('active');
    });
    // Füge die Klasse "active" nur zum gehoverten Element hinzu
    element2.classList.add('active');
  });
});


const scrollContainer = document.querySelector('.scroll-container-custom-pr');

let isDown = false;
let startX;
let scrollLeft;

scrollContainer.addEventListener('mousedown', (e) => {
    isDown = true;
    scrollContainer.classList.add('active');
    startX = e.pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
});

scrollContainer.addEventListener('mouseleave', () => {
    isDown = false;
    scrollContainer.classList.remove('active');
});

scrollContainer.addEventListener('mouseup', () => {
    isDown = false;
    scrollContainer.classList.remove('active');
});

scrollContainer.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollContainer.offsetLeft;
    const walk = (x - startX); // Scroll-Geschwindigkeit anpassen
    scrollContainer.scrollLeft = scrollLeft - walk;
});


document.addEventListener("DOMContentLoaded", function() {
    // Find all elements with the class 'sr-only'
    var srOnlyElements = document.querySelectorAll('.variant-picker__option .sr-only');

    // Add a click event listener to each of them
    srOnlyElements.forEach(function(element) {
        element.addEventListener('click', function(event) {
            // Call the original function (replace 'originalFunction' with the actual function name)
            originalFunction(event);

            // Reload the page after a short delay to ensure the function completes
            setTimeout(function() {
                location.reload();
            }, 100); // Adjust the delay if necessary
        });
    });
});

// Define the original function
function originalFunction(event) {
    // Original function logic goes here
}


document.addEventListener('DOMContentLoaded', function() {
  // Warten, bis das DOM vollständig geladen ist
  var productThumbnail = document.querySelector('.productThumbnails.product-gallery__thumbnail img');

});


